import React, { useMemo } from "react"

const CUBES = [
  { x: "18%", y: "58%", d: "0s", s: 1 },
  { x: "28%", y: "52%", d: "0.25s", s: 0.85 },
  { x: "38%", y: "60%", d: "0.5s", s: 1.1 },
  { x: "55%", y: "50%", d: "0.75s", s: 0.9 },
  { x: "65%", y: "58%", d: "1s", s: 1 },
  { x: "74%", y: "48%", d: "1.25s", s: 0.8 },
]

/**
 * Writing wallpaper — isometric draft forge.
 * Sharp geometric cubes, blueprint rails, snap beams. No soft ink/HUD reticle reuse.
 * Decorative only (no readable text). Fully responsive via CSS breakpoints.
 */
export default function WritingScene({ layerRef }) {
  const rails = useMemo(
    () =>
      Array.from({ length: 5 }, (_, i) => ({
        i,
        top: `${22 + i * 12}%`,
        delay: `${i * 0.55}s`,
        dur: `${4.5 + i * 0.4}s`,
      })),
    []
  )

  return (
    <div
      ref={layerRef}
      className="writing-wallpaper fixed inset-0 pointer-events-none z-[1] overflow-hidden"
      aria-hidden
    >
      <div className="writing-forge-glow writing-forge-glow--a" />
      <div className="writing-forge-glow writing-forge-glow--b" />

      {/* Isometric blueprint field */}
      <div className="writing-iso-field">
        <div className="writing-iso-grid" />
        <div className="writing-iso-vanish" />
      </div>

      {/* Blueprint dash rails */}
      <div className="writing-forge-rails">
        {rails.map((r) => (
          <span
            key={r.i}
            className="writing-forge-rail"
            style={{
              top: r.top,
              animationDelay: r.delay,
              animationDuration: r.dur,
            }}
          />
        ))}
      </div>

      {/* Assembling isometric cubes */}
      <div className="writing-iso-stack">
        {CUBES.map((c, i) => (
          <span
            key={i}
            className="writing-iso-cube"
            style={{
              left: c.x,
              top: c.y,
              "--cube-scale": c.s,
              animationDelay: c.d,
            }}
          >
            <span className="writing-iso-face writing-iso-face--top" />
            <span className="writing-iso-face writing-iso-face--left" />
            <span className="writing-iso-face writing-iso-face--right" />
          </span>
        ))}
      </div>

      {/* Snap cursor lattice */}
      <div className="writing-snap-field">
        <span className="writing-snap writing-snap--1" />
        <span className="writing-snap writing-snap--2" />
        <span className="writing-snap writing-snap--3" />
        <span className="writing-snap writing-snap--4" />
      </div>

      {/* Composition beam */}
      <div className="writing-compose-beam" />
      <div className="writing-compose-beam writing-compose-beam--alt" />

      {/* Edge chevrons */}
      <span className="writing-chevron writing-chevron--l" />
      <span className="writing-chevron writing-chevron--r" />
    </div>
  )
}
